import { feathers } from '@/feathers-client';

/**
 * It finds the leads associated with a userId.
 * First it makes a request to "/agents" (structurely) to get agent Id
 * Secondly, and if user is an agent it will make a request to "/leads" (structurely)
 * to get the leads object.
 *
 * @param {Integer} userId - ID of the user you want to retrieve leadAssist agent info for
 * @param {String} contactPhone - the contact's phone number
 */
const getLeads = async (userId, contactPhone) => {
  const agentsResponse = await feathers.service('lead-assist/agents').find({
    query: { userId },
  });

  const agent = agentsResponse.agents[0];
  if (!agent) return;

  const result = await feathers.service('lead-assist/leads').find({
    query: {
      ownerId: agent.id,
      phone: contactPhone,
    },
  });

  return result.leads;
};

const initialState = {
  error: '',
  lead: null,
  isLoading: false,
  isContactMuted: true,
};

export default {
  namespaced: true,
  state: { ...initialState },

  mutations: {
    setIsLoading(state, bool) {
      state.isLoading = bool;
    },
    setError(state, error) {
      state.error = `Error connecting to Lead Assist: ${error}`;
    },
    setLeadAssistLead(state, lead) {
      state.lead = lead;
      if (lead) state.isContactMuted = lead.muted;
    },
  },

  actions: {
    /**
     * @param {Integer} currentUserId - current user's ID
     * @param {Integer} assignedUserId - ID of user assigned to the contact
     * @param {String} contactPhone - mobile phone number of the contact
     */
    async getLeadAssistLead({ commit }, { currentUserId, assignedUserId, contactPhone }) {
      commit('setIsLoading', true);
      commit('setLeadAssistLead', null);

      try {
        const leadsByCurrentUser = await getLeads(currentUserId, contactPhone);
        if (leadsByCurrentUser && leadsByCurrentUser.length > 0) {
          commit('setLeadAssistLead', leadsByCurrentUser[0]);
          commit('setIsLoading', false);
        } else {
          if (assignedUserId) {
            const leadsByAssignedUser = await getLeads(assignedUserId, contactPhone);
            if (leadsByAssignedUser && leadsByAssignedUser.length > 0) {
              commit('setLeadAssistLead', leadsByAssignedUser[0]);
            }
          }

          commit('setIsLoading', false);
        }
      } catch (error) {
        commit('setError', error.message);
      }
    },

    async toggleMuteLeadAssist({ commit }, { leadId, isMuted }) {
      commit('setIsLoading', true);
      try {
        const response = await feathers.service('lead-assist/leads').patch(
          leadId,
          { muted: isMuted },
        );

        commit('setLeadAssistLead', response);
      } catch (error) {
        commit('setError', error.message);
      }
      commit('setIsLoading', false);
    },
  },
};
